(ns practitest.frontend.components2.dashboard.transforms.stacked-bar
  (:require [practitest.frontend.components2.dashboard.transforms.bar :as b]))

(defn transform
  "Stacked bar charts render b/base-transform's flat rows as-is —
   no url-params, since this chart has no on-bar-click navigation."
  [chart]
  (b/base-transform chart))
